import React from 'react';
import { useFileViewPresenter } from './FileView.presenter';

import { Link } from 'components/primitives/link';
import { Modal } from 'components/primitives/modal';
import { ToolTip } from 'components/primitives/tooltip';
import { PDFViewer } from './PDFViewer/PDFViewer';

import { VOID_FUNCTION } from 'constants';
import { IMG_FORMATS, LIST_OPTIONS } from '../../FileUpload.constants';

import { CarPreloaderGif, CloseSvg } from 'assets/img';
import { PlaceholderPng } from 'assets/img';
import * as S from './FileView.styles';

export const FileView = ({
  documentData,
  documentTypes = [],
  classify = false,
  onChange = VOID_FUNCTION,
  onDelete = VOID_FUNCTION,
  onClose = VOID_FUNCTION,
}) => {
  const presenter = useFileViewPresenter({
    documentData,
    documentTypes,
    classify,
    onDelete,
    onClose,
  });

  return (
    <Modal position="fixed">
      <S.Wrapper data-test={`FileView-Wrapper`}>
        <S.CloseButton data-test={`FileView-CloseButton`} onClick={() => onClose(null)}>
          <CloseSvg />
        </S.CloseButton>
        <S.FileWrapper>
          {!presenter.imagesLoaded ? (
            <S.Loader src={CarPreloaderGif} color="white" />
          ) : (
            <>
              <S.Header control={presenter.changeDocumentType}>
                {!presenter.changeDocumentType ? (
                  <>
                    <S.Title>{presenter.getTitle}</S.Title>
                    <S.Desc>{`Страница ${presenter.getPageNumber}`}</S.Desc>
                  </>
                ) : (
                  <>
                    {presenter.classify && (
                      <S.TitleChangeType>
                        Нам не удалось распознать документы.
                        <br />
                        Пожалуйста, выберите вручную тип документа для каждого изображения
                      </S.TitleChangeType>
                    )}

                    {presenter.documentTypes?.length > 0 && (
                      <S.ChangeType>
                        <S.TypesSelect
                          name="type"
                          defaultValue={presenter.documentType}
                          label="Тип документа"
                          list={presenter.documentTypes}
                          onlyid={false}
                          onChange={({ type }) => presenter.setDocumentType(type)}
                        />
                        <S.SaveType
                          type="primary"
                          dataTest={`FileView-SaveButton`}
                          onClick={() => {
                            !presenter.classify && presenter.setChangeDocumentType(false);
                            onChange(
                              presenter.documentsImg[presenter.page],
                              presenter.documentType.sysName
                            );
                          }}
                        >
                          Сохранить
                        </S.SaveType>
                        <S.CancelType
                          dataTest={`FileView-CancelButton`}
                          onClick={() => presenter.setChangeDocumentType(false)}
                        >
                          Отмена
                        </S.CancelType>
                      </S.ChangeType>
                    )}
                  </>
                )}
              </S.Header>
              <S.Controls>
                {!presenter.changeDocumentType &&
                  presenter.controls.map(
                    (control, index) =>
                      !control.hidden && (
                        <ToolTip
                          text={control.name}
                          key={`_control_${index + 1}`}
                          position="bottom"
                        >
                          <S.ControlButton
                            dataTest={control.dataTest}
                            onClick={() => control.func()}
                          >
                            <Link>{control.icon}</Link>
                            {presenter.showMenu && control.menu && control.menu}
                          </S.ControlButton>
                        </ToolTip>
                      )
                  )}
              </S.Controls>

              {presenter.showImgView && (
                <S.View
                  other={presenter.changeDocumentType && presenter.documentType.id === 3381}
                  classify={presenter.classify}
                >
                  <S.ControlView>
                    {presenter.showLeftControl && (
                      <S.NavLeft
                        data-test={`FileView-Control-left`}
                        onClick={() => presenter.setPage((prev) => prev - 1)}
                      >
                        <S.Icon />
                      </S.NavLeft>
                    )}
                  </S.ControlView>
                  <S.ImgZoomWrapper data-test={`FileView-ImgZoomWrapper`}>
                    {presenter.showImgZoom && (
                      <S.ImgZoom src={presenter.documentsImg[presenter.page].imgUrl} />
                    )}
                  </S.ImgZoomWrapper>
                  <S.ControlView>
                    {presenter.showRightControl && (
                      <S.NavRight
                        data-test={`FileView-Control-right`}
                        onClick={() => presenter.setPage((prev) => prev + 1)}
                      >
                        <S.Icon />
                      </S.NavRight>
                    )}
                  </S.ControlView>
                </S.View>
              )}

              {presenter.showPDFViewer && (
                <PDFViewer src={`${presenter.documentsImg[presenter.page].imgUrl}?preview=1`} />
              )}
              <S.List>
                {presenter.showCarousel && (
                  <S.CarouselStyled
                    settings={LIST_OPTIONS}
                    activeIndex={presenter.secondPage}
                    count={presenter.documentsImg && presenter.documentsImg.length}
                    dataTest={`FileView-Carousel`}
                    onIndexChanged={({ index }) => presenter.setSecondPage(index)}
                  >
                    {presenter.documentsImg &&
                      presenter.documentsImg.map((document, index) => (
                        <S.ImgWrapper key={index}>
                          {IMG_FORMATS.includes(document.mimeType) ? (
                            <S.ImgThumb
                              src={document.imgUrl}
                              onClick={() => presenter.setPage(index)}
                            />
                          ) : (
                            <S.ImgThumb
                              src={PlaceholderPng}
                              onClick={() => presenter.setPage(index)}
                            />
                          )}
                        </S.ImgWrapper>
                      ))}
                  </S.CarouselStyled>
                )}
              </S.List>
            </>
          )}
        </S.FileWrapper>
      </S.Wrapper>
    </Modal>
  );
};
